import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {
  public description: string = '';
  public type: string = 'sucess'
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {
    this.description = data.description;
    this.type = data.type;
   }

  ngOnInit() {
  }

}
